var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_vm._v(" "+_vm._s(_vm.displayText)+" "),(_vm.limitExceeed)?_c('span',{staticClass:"read-more__link",domProps:{"innerHTML":_vm._s(_vm.toggleLabel)},on:{"click":_vm.toggleReadMore}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }